if (process.env.BUILD_GC === 'usercenter' || process.env.BUILD_GC === 'cicp') {
  module.exports = require('./user')
} else {
  module.exports = null
}
